import { authedFetch } from '@/lib/authed-fetch';

type MemberQrTokenResponse = Readonly<{
  jwt: string;
}>;

/** The member's identity code. It is not scoped to an event — see member-qr+api. */
async function fetchMemberQrJwt(signal?: AbortSignal): Promise<MemberQrTokenResponse> {
  const response = await authedFetch('/api/member-qr', { signal });
  const payload = (await response.json().catch(() => null)) as
    (MemberQrTokenResponse & { error?: string }) | null;

  if (!response.ok || !payload?.jwt) {
    throw new Error(payload?.error ?? 'Could not create member QR code.');
  }

  return payload;
}

export { fetchMemberQrJwt };
export type { MemberQrTokenResponse };
